import { Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import { EditOutlined, MoreVertOutlined } from "@mui-symbols-material/w300"
import type { CellContext } from "@tanstack/react-table"
import type { FC } from "react"
import { useRef, useState } from "react"

import TestTemplateFormDialog from "../TestTemplateForm/TestTemplateFormDialog"
import TestTemplateInUseDialog from "../TestTemplateInUseDialog"

import type { TestTemplate } from "@/graphql/codegen/graphql"

enum DialogType {
  Form = "FORM",
  InUse = "IN_USE",
}

interface TestTemplateRowActionsProps {
  row: CellContext<TestTemplate, unknown>["row"]
  onRefresh: () => void
}

const TestTemplateRowActions: FC<TestTemplateRowActionsProps> = ({ row, onRefresh }) => {
  const anchorElRef = useRef<HTMLButtonElement>(null)
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const [openedDialog, setOpenedDialog] = useState<DialogType | null>(null)

  const handleDropdownOpen = () => setIsDropdownOpen(true)

  const handleDropdownClose = () => setIsDropdownOpen(false)

  const handleFormDialogOpen = () => {
    setIsDropdownOpen(false)
    setOpenedDialog(row.original.associatedTestTemplatesCount ? DialogType.InUse : DialogType.Form)
  }

  const handleFormDialogSubmit = () => {
    setOpenedDialog(null)
    onRefresh()
  }

  const handleDialogClose = () => setOpenedDialog(null)

  return (
    <Box className='flex items-center' ref={anchorElRef}>
      <IconButton onClick={handleDropdownOpen} data-test='row-actions-button'>
        <MoreVertOutlined />
      </IconButton>
      <Menu
        anchorEl={anchorElRef.current}
        open={isDropdownOpen}
        onClose={handleDropdownClose}
        data-test='row-actions-menu'
      >
        <MenuItem data-test='edit-menu-item' onClick={handleFormDialogOpen}>
          <ListItemIcon>
            <EditOutlined sx={{ fontVariationSettings: '"wght" 300' }} />
          </ListItemIcon>
          <ListItemText primary='Edit' />
        </MenuItem>
      </Menu>
      {openedDialog === DialogType.Form && (
        <TestTemplateFormDialog
          testTemplate={row.original}
          onSubmit={handleFormDialogSubmit}
          onClose={handleDialogClose}
        />
      )}
      {openedDialog === DialogType.InUse && <TestTemplateInUseDialog onClose={handleDialogClose} />}
    </Box>
  )
}

export default TestTemplateRowActions
